module.exports = __webpack_public_path__ + "static/media/insu-april.03ad9821.png";